import Header from "../common/Header";
import Sidebar from "../common/Sidebar";

export default function SuperDmtThree() {
  return (
    <>
      <Header />
      <div className="adminuiux-wrap">
        <Sidebar />
        <main
          className="adminuiux-content has-sidebar"
        >
          {/*mt-4*/}
          <div className="container " id="main-content">
            <div className="row align-items-center">
            </div>
            <input type="hidden" id="mtime" />
            <input type="hidden" id="sta" />
            <input type="hidden" id="my_limit" />
            <input type="hidden" id="sender_id" />
            <input type="hidden" id="senderState" />
            <input type="hidden" id="fucking_id" />
            <input type="hidden" id="kycStateId" />
            <input type="hidden" id="delete_bene_id" />
            <input type="hidden" id="OtpStateId" />
            <input type="hidden" id="sender_name_value" />
            <input
              type="hidden"
              name="_token"
              defaultValue="InlZOG9GSyo0HnY2yMVG4fmokCrRIEhuBFop87uz"
            />{" "}
            <div className="row">
              <div className="col-md-12 mb-5">
                <h5>Tatkal 2 Transfer</h5>
              </div>
              <div className="col-12">
                <div className="card adminuiux-card mb-4">
                  <div className="card-body pb-0">
                    <div className="row">
                      <div className="col-md-8" id="sender-search-box">
                        <div className="row">
                          <h6 className="mb-3">Search Sender</h6>
                          <div className="col-md-5">
                            <div className="input-group">
                              <input
                                className="form-control border-end-0"
                                placeholder="Sender Number"
                                id="sender_number"
                                aria-describedby="button-addon2"
                                autoComplete="off"
                                maxLength={10}
                              />
                              <button
                                className="btn btn-lg btn-theme btn-square"
                                onclick="mobile_verify()"
                                id="mobile_verify_btn"
                              >
                                <i className="bi bi-search" />
                              </button>
                            </div>
                            {/* <div class="invalid-feedback">Please enter valid input</div> */}
                          </div>

                        </div>
                      </div>
                      <div
                        className="col-md-4"
                        style={{ display: "none" }}
                        id="sender_detail"
                      >
                        <div className="row">
                          <div className="col-md-12">
                            <h6 className="mb-3">Search Sender</h6>
                            <p className="text-secondary mb-1">
                              NAME : <span id="sender_name_text" />{" "}
                              <span className="mx-2">|</span> LIMIT :{" "}
                              <span
                                className="badge badge-light rounded-pill text-bg-success"
                                id="bank2_limit"
                              />
                            </p>
                          </div>
                        </div>
                      </div>

                      <div
                        className="col-md-6"
                        style={{ display: "none" }}
                        id="search_account"
                      >
                        <div className="input-group">
                          <input
                            className="form-control border-end-0"
                            placeholder="Sender Number"
                            id="saccount"
                            aria-describedby="button-addon2"
                          />
                          <button
                            className="btn btn-lg btn-theme btn-square"
                            onclick="bene_list('0')"
                          >
                            <i className="bi bi-search" />
                          </button>
                          &nbsp;
                          <button
                            className="btn btn-primary"
                            onclick="bene_list('1')"
                            type="button"
                          >
                            View All
                          </button>
                          &nbsp;
                          <button
                            className="btn btn-primary"
                            onclick="tatkal_bene_list('1')"
                            type="button"
                          >
                            Tatkal Bene
                          </button>
                        </div>
                      </div>
                    </div>
                    <br />
                  </div>
                </div>
              </div>
              <div className="col-12" style={{ display: "none" }} id="bene_list_box">
                <div className="card adminuiux-card mb-4">
                  <div className="card-body pb-0">
                    <div className="row">
                      <div className="col-md-6">
                        <h6 className="mb-3">Beneficiary List</h6>
                      </div>
                      <div className="col-md-6">
                        <button
                          className="btn btn-theme float-right"
                          data-bs-toggle="modal"
                          data-bs-target="#addBeneModal"
                        >
                          Add Beneficiary
                        </button>
                      </div>
                    </div>
                    <br />
                    <table className="table w-100 nowrap table-responsive" id="">
                      <thead>
                        <tr>
                          <th>Verify</th>
                          <th>Name</th>
                          <th>Bank Name</th>
                          <th className="float-left">Account No</th>
                          <th>Ifsc</th>
                          <th>Bank Pipe</th>
                          <th>Amount</th>
                          <th>IMPS</th>
                          <th>NEFT</th>
                        </tr>
                      </thead>
                      <tbody id="bene_list"></tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>

      </div>
    </>
  );
}